import React from 'react'
import PageContent from 'components/pages/PageContent'

const InventoryManifestPage = () => (
  <PageContent title="Inventory Manifest">
    <div>Inventory manifest view is available in legacy reference and will be reconnected during migration.</div>
  </PageContent>
)

export default InventoryManifestPage
